import * as R from 'ramda';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';
import { BoundWhiteLabelSelectors } from 'reactApp/modules/WhiteLabelModule/WhiteLabelModule';

import router from './router';

// a dictionary of reusable links of various types - urls, route ids, etc., to be the only source of truth
const LinkCatalog = {
    getCurrentAppSupportUrl() {
        const whiteLabelSettings = BoundWhiteLabelSelectors.getWhiteLabelSettings();

        if (whiteLabelSettings) {
            const url = R.path(
                ['support_contacts', 'question_form_url'],
                whiteLabelSettings,
            );

            if (url) {
                return url;
            }
        }

        return router.isPartnerApp()
            ? 'mailto:partner@mcs.mail.ru?Subject=Вопрос в техподдержку партнерской программы MCS'
            : LinkCatalog.getMainAppSupportUrl();
    },

    getMainAppSupportUrl() {
        const whiteLabelSettings = BoundWhiteLabelSelectors.getWhiteLabelSettings();

        if (whiteLabelSettings) {
            const link = R.path(
                ['support_contacts', 'support_link'],
                whiteLabelSettings,
            );

            if (link) {
                return link;
            }
        }

        return 'https://help.mail.ru/mcs/support';
    },

    getInfraSupportUrl() {
        const supportEmail = R.path(
            ['support_contacts', 'email'],
            BoundWhiteLabelSelectors.getWhiteLabelSettings(),
        );
        const userEmail = BoundCurrentUserSelectors.getEmail();
        const defaultInfraSupportUrl = 'https://help.mail.ru/infra/support';
        const mailSubject = `?subject=${userEmail}${encodeURI(
            ' обращение в службу поддержки',
        )}`;

        return supportEmail
            ? `mailto:${supportEmail}${mailSubject}`
            : defaultInfraSupportUrl;
    },

    getTermOfUseUrl() {
        return 'https://help.mail.ru/mcs/legal/termofuse';
    },

    getPrivacyUrl() {
        return 'https://help.mail.ru/mcs/legal/privacy';
    },
    getInfraOffersUrl() {
        return '/cloud-servers/#pricing';
    },
};

export { LinkCatalog };
